module.exports = {"TXTCLI_Confirm_Details":{"id":"TXTCLI_Confirm_Details","defaultMessage":"Επιβεβαίωση στοιχείων","track":"Confirm Details"}}